import { render, staticRenderFns } from "./centerApprovalModal.vue?vue&type=template&id=7fdebd32&"
import script from "./centerApprovalModal.vue?vue&type=script&lang=js&"
export * from "./centerApprovalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports